import styled from "@emotion/styled";
import { Link } from "react-aria-components";
import { MDSChipVariant } from "./chip.types";
import { MDSIconButton } from "@/mds/components/buttons/icon-button";
import { MDSText } from "@/mds/components/text";

export const StyledInner = styled.div<{ maxWidth?: number | string }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["1"]};
  max-width: ${({ maxWidth }) =>
    typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth || "200px"};
  min-width: 0;
  flex-shrink: 0;
`;

export const StyledText = styled(MDSText)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

export const StyledChipButton = styled(Link)<{ $variant: MDSChipVariant }>`
  display: inline-flex;
  white-space: nowrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-shrink: 0;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  outline: none;
  border: none;
  cursor: pointer;
  transition: 0.25s ease;
  user-select: none;

  padding-block: ${({ theme, $variant }) =>
    $variant === MDSChipVariant.Small ? theme.spacing["0.5"] : theme.spacing["1"]};
  padding-inline: ${({ theme, $variant }) =>
    $variant === MDSChipVariant.Small ? theme.spacing["1"] : theme.spacing["2"]};

  font-weight: ${({ theme }) => theme.fontWeights.regular};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};

  background-color: ${({ theme }) => theme.colors.background.button.chip.default};
  color: ${({ theme }) => theme.colors.text.primary};
  box-shadow: none;

  &[data-hovered]:not([data-disabled]) {
    background-color: ${({ theme }) => theme.colors.background.button.chip.hover};
    transition: 0.2s all;
  }

  &[data-pressed]:not([data-disabled]) {
    background-color: ${({ theme }) => theme.colors.background.button.chip.hover};
    transition: 0.2s all;
  }

  &[data-disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }

  [data-mds-name="icon-button"] .mds-icon {
    color: ${({ theme }) => theme.colors.icon.placeholder};
    fill: ${({ theme }) => theme.colors.icon.placeholder};
    width: ${({ $variant }) => ($variant === MDSChipVariant.Small ? "13px" : "16px")};
    height: ${({ $variant }) => ($variant === MDSChipVariant.Small ? "13px" : "16px")};
    font-size: ${({ theme, $variant }) =>
      $variant === MDSChipVariant.Small ? theme.fontSizes["text-xs"] : theme.fontSizes["text-s"]};
  }
`;

export const StyledRemoveButton = styled(MDSIconButton)`
  padding: 0;
`;
